/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Path {
    INCOMING = 'Incoming',
    OUTGOING = 'Outgoing',
}
